import { render } from "./topicManagerInfo.vue?vue&type=template&id=4db3bbd2&scoped=true"
import script from "./topicManagerInfo.vue?vue&type=script&lang=js"
export * from "./topicManagerInfo.vue?vue&type=script&lang=js"

import "./topicManagerInfo.vue?vue&type=style&index=0&id=4db3bbd2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db3bbd2"]])

export default __exports__